import { Component, OnInit,OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { EchexbaseComponent } from '../echexbase/echexbase.component';
;

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';
import {  ViewChild, ElementRef, Renderer2  } from '@angular/core';

@Component({
  selector: 'echexpayment-sendcheck',
  templateUrl: './sendcheck.component.html',
  styleUrls: ['./sendcheck.component.css']
})
export class SendcheckComponent extends EchexbaseComponent implements OnInit , OnDestroy{
	public sendCheck: any={};
	public token: string;
	public user_id: string;
	public data;
	public profile;
	busy1: Subscription;
	public amountWords :string;
	public to_name :string;
	public  descriptiondata : string;
	public  today_date : Date;
	public  check_number : string;
	public  invalidEmalAddress : boolean = false;
	public  val_name : boolean = false;
	public  val_email : boolean = false;
	public  val_description : boolean = false;
	public  val_check_amount : boolean = false;
  public Business_name : string;
  public formTouched : boolean = false;
	public showWarning: boolean = false;
  public characterLimitReached : boolean = false;

  NamecharacterLimitReached: { [key: string]: boolean } = {};
  
	constructor(protected router: Router,private elementRef: ElementRef, protected route: ActivatedRoute, private renderer: Renderer2, protected toastr: ToastrService, protected userService:UserService, protected echexpaymentService :EchexpaymentService, protected localStorageService: LocalstorageService) { 
	
	super(route, router, toastr, userService, echexpaymentService, localStorageService);

	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;
	
	let userDetails = this.localStorageService.getData("currentUser");
 	this.user_id = userDetails._id;
  this.Business_name = userDetails.business_name;
	this.today_date =  new Date();


	}

  ngOnDestroy() {
    this.toastr.clear();
  }

	ngOnInit() {
		this.getprofileDetails(); 
	}
	
  ngAfterViewInit() {
		this.renderer.selectRootElement('#Focus_name').focus();
	}
	  
	@ViewChild('submitButton') submitButton: ElementRef;
  moveNext(nextInput: HTMLInputElement, checkbox: number) {
    if(checkbox === 2){
      if (this.submitButton && this.submitButton.nativeElement) {
        this.submitButton.nativeElement.focus();
        this.submitButton.nativeElement.click();
      }
    } else{
      nextInput && nextInput.focus();
    }
  }

	eventHandler(){
      this.invalidEmalAddress = false;
    }
	
	// Convert amount number in to words
    numberInWords(value) {
      if (value === null || value === undefined) {
        this.amountWords = '';
      } else {
        const dollars = Math.floor(value);
        const cents = Math.round((value - dollars) * 100);
        // const centsFraction = cents === 0 ? '00' : `${cents}/100`;
    
        // return this.amountWords = `${this.echexpaymentService.toWords(dollars)} and ${centsFraction}`;
        let centsText = '';
        
        if (cents !== 0) {
          centsText = `${cents}/100`;
        } else {
          centsText = `00/100`;
        }
  
        this.amountWords = `${this.echexpaymentService.toWords(dollars)}`;
  
        if (centsText) {
          this.amountWords += ` and ${centsText} Cents`;
        }
      }
    }
    //setAmountValue
    setAmountValue(amount){
      if(amount) {
        this.sendCheck.amount = parseFloat(amount).toFixed(2);
      }
    }

    limitDecimalLength(inputElement: HTMLInputElement) {
      const regex = /^\d{0,9}(\.\d{0,2})?$/;
      const inputValue = inputElement.value;
      
      if (!regex.test(inputValue)) {
        inputElement.value = inputValue.slice(0, -1);
      }
    }

    DisallowZero(event: any) {
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
      const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
    
      if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
        // Allow the default behavior for certain keys
        return;
      }
    
      const inputValue = event.target.value;
      const caretStart = event.target.selectionStart;
      const caretEnd = event.target.selectionEnd;
      const modifiedValue = inputValue.slice(0, caretStart) + event.key + inputValue.slice(caretEnd);
      
      if (modifiedValue !== '' && !/^\d*\.?\d*$/.test(modifiedValue)) {
        this.showWarning = false; // Hide the warning message
        event.preventDefault(); // Prevent invalid input
        return;
      }
      const regex = /^\d{0,9}(\.\d{0,2})?$/;
      const maxValue = 999999999;
      if (!regex.test(modifiedValue) || parseFloat(modifiedValue) > maxValue) {
        if (parseFloat(modifiedValue) > maxValue) {
          this.showWarning = true;
          setTimeout(() => {
            this.showWarning = false;
          }, 3000);
          event.preventDefault();
        }
        event.preventDefault();
      } 
    }

    	


    focusFirstInvalidControlPlus(): void {
      const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
      if (firstElementWithErrors) {
          firstElementWithErrors.focus();
      }
    }

	// Save send cheque
	saveSendCheck(data){
    this.formTouched = true;
    this.focusFirstInvalidControlPlus();   //focus field
    if(data.valid){
      let model: any = data.value;
        model.user_token =   this.token;
        model.token =   this.user_id;
        model._id = this.user_id;
        model.to_name = model.name;
        model.cheque_number = this.check_number;
		    let responseData = <any>{};
        this.busy1 = this.echexpaymentService.createSendCheckApi(model).subscribe(
          response => {
            responseData = response;
            this.toastr.success(responseData.message, 'Success!');
            this.sendCheck.name = '';
            this.sendCheck.amount = '';
            this.sendCheck.email = '';
            this.sendCheck.memo = '';
            this.amountWords = '';
            this.sendCheck = {};
            // this.Business_name = '';
            this.getprofileDetails();
            this.formTouched = false;
          },
           error => {
              responseData = error;
              this.toastr.error(responseData.error.message, 'Failed!');
          }
      );
    }
  }

  checkCharacterLimit(event: any) {
		const maxTextLength = 20; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  return;
		}
		const inputValue = event.target.value;
		
		if (inputValue.length >= maxTextLength) {
		  if (allowedKeys.indexOf(inputChar) === -1) {
		  this.characterLimitReached = true; // Set the validation flag to true to show the warning message
		  setTimeout(() => {
			this.characterLimitReached = false; // Hide the warning message after 3 seconds
		  }, 3000);
		  event.preventDefault(); // Prevent entering the exceeded character
		  }
		}
	}




  NameCharacterLimit(event: any, fieldName: string, max_length:number) {
    const maxTextLength = max_length; // Maximum text length of 20 characters
    const inputChar = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
    const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter

    if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
        return;
    }

    const inputValue = event.target.value;

    if (inputValue.length >= maxTextLength) {
        if (allowedKeys.indexOf(inputChar) === -1) {
            this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
            setTimeout(() => {
            this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
            }, 3000);
            event.preventDefault(); // Prevent entering the exceeded character
        }
    }
}

isNameLimitReached(fieldName: string): boolean {
    return this.NamecharacterLimitReached[fieldName];
}

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/sendcheck/sendcheck.component.ts